module.exports = __webpack_public_path__ + "fonts/SFUIText-Heavy.7fefe871.eot";